import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationCN from "./locales/cn/translation.json";
import translationEN from "./locales/en/translation.json";
import translationES from "./locales/es/translation.json";
import translationJP from "./locales/jp/translation.json";
import translationKR from "./locales/ko/translation.json";
import { I18nService } from "./services/i18nService";
import { getDefaultLanguage } from "./toStdLanguages";

const resources = {
  en: {
    translation: translationEN,
  },
  us: {
    translation: translationEN,
  },
  ko: {
    translation: translationKR,
  },
  kr: {
    translation: translationKR,
  },
  jp: {
    translation: translationJP,
  },
  ja: {
    translation: translationJP,
  },
  cn: {
    translation: translationCN,
  },
  es: {
    translation: translationES,
  },
};

const defaultLng = getDefaultLanguage();
i18n.use(initReactI18next).init({
  resources,
  lng: defaultLng, // Ngôn ngữ mặc định
  fallbackLng: "en", // Ngôn ngữ dự phòng
  interpolation: {
    escapeValue: false, // Không cần escape HTML
  },
  detection: {
    order: ["localStorage", "navigator"], // IMPORTANT!
  },
});
console.log("Default language set to:", i18n.language);
/**
 * Extended i18n instance with remote loading capabilities.
 * This provides backward compatibility while adding remote features.
 */
export const i18nExtended = {
  ...i18n,

  /**
   * Loads remote translations for the current or specified language.
   *
   * @param {string} language - Optional language to load. Uses current if not specified.
   * @param {object} filters - Additional filters for remote loading
   */
  async loadRemote(language?: string, filters = {}) {
    try {
      const targetLanguage = language || i18n.language;
      await I18nService.loadRemoteTranslations({
        language: targetLanguage,
        ...filters,
      });
      console.log(`Remote translations loaded for ${targetLanguage}`);
    } catch (error) {
      console.warn("Failed to load remote translations:", error);
    }
  },

  /**
   * Refreshes current language translations from remote source.
   */
  async refresh() {
    try {
      await I18nService.refreshTranslations({ language: i18n.language });
    } catch (error) {
      console.warn("Failed to refresh translations:", error);
    }
  },
};

// // Auto-load remote translations on initialization
// if (process.env.REACT_APP_ENABLE_REMOTE_I18N !== "false") {
//   i18nExtended
//     .loadRemote(defaultLng, {
//       scope: "GLOBAL",
//     })
//     .catch((error) => {
//       console.warn("Failed to auto-load remote translations:", error);
//     });
// }

export default i18n;
